import api from "./api";

export async function loadCompanyPromptValues() {
  const variables = [];
  let page = 1;
  let hasMore;
  do {
    const { data } = await api.get("/prompt-values", { params: { page } });
    variables.push(...(data.variables || []));
    hasMore = data.hasMore;
    page += 1;
  } while (hasMore);
  return Array.from(
    new Map(variables.map((variable) => [variable.id, variable])).values()
  );
}

export const companyValueError = (error) =>
  ({
    ERR_COMPANY_VALUE_KEY_EXISTS:
      "Esta chave já está cadastrada na sua empresa.",
    ERR_COMPANY_VALUE_KEY_IMMUTABLE:
      "A chave de uma variável salva não pode ser alterada.",
    ERR_COMPANY_VALUE_IN_USE:
      "Remova o vínculo nos agentes antes de excluir esta variável.",
    ERR_COMPANY_VALUE_TYPE_IN_USE:
      "O tipo e as opções não podem mudar enquanto houver agentes vinculados.",
    ERR_COMPANY_VALUE_NOT_FOUND:
      "Esta variável não está disponível na sua empresa. Atualize a lista.",
    ERR_COMPANY_VALUE_INVALID:
      "Preencha um valor válido para o tipo selecionado.",
    ERR_SMART_VALUES_DOCUMENT_INVALID:
      "Revise o nome, a chave, o tipo e os limites dos campos.",
  }[error.response?.data?.error] ||
  "Não foi possível concluir a operação. Suas alterações foram mantidas.");
